/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAhiSeriesProductDetailPageLinkData } from './ahi-series-product-detail-page-link.data';
import { IAhiSeriesProductDetailPageLinkProps } from './ahi-series-product-detail-page-link.props.autogenerated';
import { getProductUrlSync } from '@msdyn365-commerce-modules/retail-actions';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

export interface IAhiSeriesProductDetailPageLinkViewProps
    extends IAhiSeriesProductDetailPageLinkProps<IAhiSeriesProductDetailPageLinkData> {
    productUrl: string;
}

/**
 *
 * AhiSeriesProductDetailPageLink component
 * @extends {React.PureComponent<IAhiSeriesProductDetailPageLinkProps<IAhiSeriesProductDetailPageLinkData>>}
 */
class AhiSeriesProductDetailPageLink extends React.PureComponent<
    IAhiSeriesProductDetailPageLinkProps<IAhiSeriesProductDetailPageLinkData>
> {
    public render(): JSX.Element | null {
        const products = this.props.data.products?.result;
        const category = this.props.data.category?.result;
        const product = products?.products?.[0];
        // console.log('products', products);
        const productUrl = product ? getProductUrlSync(product as SimpleProduct, this.props.context.actionContext, category) : '';
        // console.log('productUrl', productUrl);
        return this.props.renderView({ ...this.props, productUrl });
    }
}

export default AhiSeriesProductDetailPageLink;
